"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormPrompt = void 0;
const react_1 = require("react");
const FormPrompt = (props) => {
    (0, react_1.useEffect)(() => {
        const onBeforeUnload = (e) => {
            if (props.hasUnsavedChanges) {
                e.preventDefault();
                e.returnValue = '';
            }
        };
        window.addEventListener('beforeunload', onBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', onBeforeUnload);
        };
    }, [props.hasUnsavedChanges]);
    return null;
};
exports.FormPrompt = FormPrompt;
